import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    rolePermissions: [],
};

const permissionSlice = createSlice({
    name: "role-permission",
    initialState,
    reducers: {
        setPermissions: (state, action) => {
            state.rolePermissions = action.payload;
        },
        clearPermissions: (state) => {
            state.rolePermissions = [];   // <-- CLEAR HERE
        },
    },
});

export const { setPermissions, clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;